export const PT_COLORS = [
    'pt-purple',
    'pt-purple-opaque-56',
    'pt-purple-opaque-8',
    'pt-purple-1',
    'pt-purple-dark',
    'white',
    'black',
    'black-opaque-8',
    'black-opaque-16',
    'black-opaque-32',
    'dark-grey',
    'grey',
    'grey-1',
    'grey-1-opaque',
    'grey-2',
    'grey-2-opaque',
    'grey-3',
    'pink',
    'raspberry',
    'raspberry-opaque',
    'light-red',
    'red',
    'orange',
    'light-yellow',
    'yellow',
    'light-mint',
    'dark-mint',
    'mint',
    'light-blue',
    'blue',
    'dark-blue',
    'light-indigo',
    'indigo',
    'purple-light'
]
